import React, { FC, useCallback, useMemo } from "react";
import { IconButton } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { useKey } from "hooks/useKey";
import { useDeleteResourcesDialog } from "../../../../hooks/useDialogs";
import { isEditable } from "../../../../evergis/core/permissions";
import { useSelectedResources } from "../../hooks/useSelectedResources";

import { ResourceInfoDc } from "../../types";

export const DeleteResources: FC = () => {
  const { t } = useTranslation("common");
  const [selected] = useSelectedResources();
  const openDeleteResourcesDialog = useDeleteResourcesDialog();
  const allSelectedDeletable = useMemo(() => allDeletable(selected as ResourceInfoDc[]), [selected]);

  const deleteSelectedCards = useCallback(() => {
    if (allSelectedDeletable) {
      const resourceNames = selected.map(({ name }) => name);

      openDeleteResourcesDialog(resourceNames);
    }
  }, [allSelectedDeletable, openDeleteResourcesDialog, selected]);

  useKey({
    Delete: deleteSelectedCards,
  });

  return (
    <IconButton
      kind={"delete"}
      title={t("actions.delete")}
      disabled={!allSelectedDeletable}
      onClick={deleteSelectedCards}
    />
  );
};

function allDeletable(resources: ResourceInfoDc[]): boolean {
  if (resources.length === 0) {
    return false;
  }

  return resources.every(resource => isEditable(resource.permissions));
}
